<template>
    <div class="tpl-content-wrapper">
        <div class="tpl-portlet-components">
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <i class="am-icon-dashboard"></i>
                    <span>我的课程</span>
                    <span class="desc">点击“更多”进入课程库，将感兴趣的课程加入课程清单，开始你的学习成长之路</span>
                </div>
                <div class="tpl-more mt-2">
                    <ul>
                        <li>
                            <router-link :to="{ name: 'courses'}" tag="a">更多
                            </router-link>
                            <!--<router-link tag="a" : to="{ name: 'dashboard', query: {'topic': dashboard.topic} }">更多-->
                            <!--</router-link>-->
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "learning_main"
    }
</script>

<style scoped>

</style>